import { render, staticRenderFns } from "./DuRegister.vue?vue&type=template&id=003876f4&scoped=true&"
import script from "./DuRegister.vue?vue&type=script&lang=js&"
export * from "./DuRegister.vue?vue&type=script&lang=js&"
import style0 from "./DuRegister.vue?vue&type=style&index=0&id=003876f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003876f4",
  null
  
)

export default component.exports